import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Select from 'react-select';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import { FaArrowRight, FaArrowDown } from 'react-icons/fa';

import DashleadAPI from '../../../api/DashleadAPI';
import MainCondition from '../../settings/condition/MainCondition';
import AutomationModule from '../../settings/automation/AutomationModule';
import withRouter from '../../../util/WithRouter';
import Const from '../../../util/Constants';
import FieldController from '../../../controller/FieldController';
import Util from '../../../util/Util';
import ApiUiController from '../../../controller/ApiUiController';
import RegEx from '../../../util/RegEx';
import ReportConst from '../../../util/ReportConst';

class DashleadUpdate extends React.Component {

  constructor(props) {
    super(props);
    this.models = reactLocalStorage.getObject(Const.Model);

    this.id = parseInt(props.match.params.id);

    this.state = {
      inApiCall: true, name: '', type: 0, view_type: 0, model: '', sub_model: '',
      x: '', y: '', z: '', filter: [], inValid: {}
    };
    this.models = reactLocalStorage.getObject(Const.Model);

    this.conditions = [];
    this.fields = [];
    this.modelFields = [];

    this.basePath = this.props.match.path;
    this.basePath = this.basePath.substring(0, this.basePath.indexOf('/add-edit'));
    this.dashlead = {};
  }

  componentDidMount() {
    DashleadAPI.get(this.id, this.onReceived, this.onFail);
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = dashlead => {
    this.dashlead = dashlead;
    this.model = this.models[this.dashlead.model];
    this.fields = FieldController.getFilterFields(this.model.fields);
    this.modelFields = [];
    const keys = Object.keys(this.model.fields);
    for (let i = 0; i < keys.length; i++) {
      this.modelFields.push({
        id: this.model.fields[keys[i]].id,
        value: this.model.fields[keys[i]].field_key,
        type: this.model.fields[keys[i]].field_type,
        label: this.model.fields[keys[i]].label_name
      });
    }
    this.dashlead.json = this.dashlead.json ? JSON.parse(this.dashlead.json) : {};
    this.conditions = this.dashlead.json.filters ? this.dashlead.json.filters : [];
    this.setState({
      ...this.state, id: this.dashlead.id, name: this.dashlead.name, model: this.dashlead.model,
      sub_model: this.dashlead.sub_model, type: this.dashlead.type, view_type: this.dashlead.view_type, x: this.dashlead.x, y: this.dashlead.y,
      inApiCall: false
    });
  };

  nameChange = event => this.setState({ ...this.state, name: event.target.value });
  onModelChange = (field, model) => {
    this.model = this.models[model];
    this.fields = FieldController.getFilterFields(this.model.fields);
    this.modelFields = [];
    const keys = Object.keys(this.model.fields);
    for (let i = 0; i < keys.length; i++) {
      this.modelFields.push({
        id: this.model.fields[keys[i]].id,
        value: this.model.fields[keys[i]].field_key,
        type: this.model.fields[keys[i]].field_type,
        label: this.model.fields[keys[i]].label_name
      });
    }
    this.setState({ ...this.state, model: model });
  };
  onSubModelChange = model => { };
  onFieldChange = (field, value) => {
    const state = { ...this.state };
    state[field] = value;
    this.setState({ ...state });
  };

  edit = conditions => this.conditions = conditions;

  onSave = () => {
    this.setState({ ...this.state, inApiCall: true });
    let filters = this.conditions.map(filter => {
      if (Object.keys(filter).length === 0) return {};
      else return {
        field: filter.field?.value,
        type: filter.field?.type, condition: filter.condition?.value, value: filter?.value
      };
    });
    this.dashlead.json.filters = filters;

    const dashlead = {
      ...this.dashlead, id: this.state.id, name: this.state.name, model: this.state.model,
      sub_model: this.state.sub_model, type: this.state.type, view_type: this.state.view_type,
      x: this.state.x, y: this.state.y, json: JSON.stringify(this.dashlead.json)
    };
    DashleadAPI.save(dashlead, this.onSaved, this.onFail);
  };
  onSaved = () => {
    Util.showNotification('Successful', 'Successfully saved.', 'success');
    this.props.navigate(this.basePath);
  };

  render() {
    const inValid = this.state.inValid;
    return (
      <div className="sectionform pt-4">
        <div className="container form-cont">
          <div className="row"><div className="col-md-12 pb-3"><h3>Dashlead</h3></div></div>

          <ApiUiController inApiCall={this.props.inApiCall}>
            <Form className="row row-cols-3 lead-form">
              <div className="col-md-4">
                <div className="form-group">
                  <FormControl type='text' placeholder="Report Name"
                    className={`mr-sm-2 ${RegEx.class(inValid, 'name')}`}
                    value={this.state.name} onChange={this.nameChange} />
                </div>
              </div>

              <div className="col-md-4">
                <label>Report Type</label>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.type === ReportConst.Select}
                    onChange={() => this.onFieldChange('type', ReportConst.Select)} />
                  <Form.Check.Label>Only Select or MultiSelect Field</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.type === ReportConst.SelectToSelect}
                    onChange={() => this.onFieldChange('type', ReportConst.SelectToSelect)} />
                  <Form.Check.Label>2 Select or MultiSelect Field</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.type === ReportConst.SelectToHr}
                    onChange={() => this.onFieldChange('type', ReportConst.SelectToHr)} />
                  <Form.Check.Label>Hourly Select or MultiSelect Field</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.type === ReportConst.SelectToDay}
                    onChange={() => this.onFieldChange('type', ReportConst.SelectToDay)} />
                  <Form.Check.Label>Daily Select or MultiSelect Field</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.type === ReportConst.SelectToMonth}
                    onChange={() => this.onFieldChange('type', ReportConst.SelectToMonth)} />
                  <Form.Check.Label>Monthly Select or MultiSelect Field</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.type === ReportConst.Consolidate}
                    onChange={() => this.onFieldChange('type', ReportConst.Consolidate)} />
                  <Form.Check.Label>Consolidated Report</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.type === ReportConst.Target}
                    onChange={() => this.onFieldChange('type', ReportConst.Target)} />
                  <Form.Check.Label>Target Report</Form.Check.Label>
                </Form.Check>
              </div>

              <div className="col-md-4">
                <label>Report View</label>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.view_type === ReportConst.List}
                    onChange={() => this.onFieldChange('view_type', ReportConst.List)} />
                  <Form.Check.Label>List</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.view_type === ReportConst.Table}
                    onChange={() => this.onFieldChange('view_type', ReportConst.Table)} />
                  <Form.Check.Label>Table</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.view_type === ReportConst.PieChart}
                    onChange={() => this.onFieldChange('view_type', ReportConst.PieChart)} />
                  <Form.Check.Label>Pie Chart</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.view_type === ReportConst.BarGraph}
                    onChange={() => this.onFieldChange('view_type', ReportConst.BarGraph)} />
                  <Form.Check.Label>Bar Graph</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.view_type === ReportConst.LineChart}
                    onChange={() => this.onFieldChange('view_type', ReportConst.LineChart)} />
                  <Form.Check.Label>Line Chart</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.view_type === ReportConst.MultiBarGraph}
                    onChange={() => this.onFieldChange('view_type', ReportConst.MultiBarGraph)} />
                  <Form.Check.Label>Multi Bar Graph</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.view_type === ReportConst.MultiLineChart}
                    onChange={() => this.onFieldChange('view_type', ReportConst.MultiLineChart)} />
                  <Form.Check.Label>Multi Line Chart</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.view_type === ReportConst.Funnel}
                    onChange={() => this.onFieldChange('view_type', ReportConst.Funnel)} />
                  <Form.Check.Label>Funnel</Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio">
                  <Form.Check.Input type="radio" checked={this.state.view_type === ReportConst.Gauge}
                    onChange={() => this.onFieldChange('view_type', ReportConst.Gauge)} />
                  <Form.Check.Label>Gauge</Form.Check.Label>
                </Form.Check>
              </div>

              <div className="col-md-4">
                <div className="formhead col-md-12"><h4>Module</h4></div>
                <AutomationModule onChange={this.onModelChange} model={this.state.model}
                  models={this.models} />
              </div>

              {/*
              <div className="col-md-4">
                <div className="formhead col-md-12"><h4>Sub Module</h4></div>
                <AutomationModule onChange={this.onSubModelChange} value={this.state.sub_model}
                  models={this.models} />
              </div>
              */}

              <div className="col-md-4">
                <div className="formhead col-md-12"><h4>X co-ordinate <FaArrowRight /></h4></div>
                <div className="condition-select col-md-12">
                  <Select
                    value={this.modelFields.find(field => field.value === this.state.x)}
                    className="mr-sm-2"
                    options={this.modelFields}
                    onChange={field => this.setState({ ...this.state, x: field ? field.value : '' })}
                    isSearchable={true} isClearable={true} />
                </div>
              </div>

              <div className="col-md-4">
                <div className="formhead col-md-12"><h4>Y co-ordinate <FaArrowDown /></h4></div>
                <div className="condition-select col-md-12">
                  <Select
                    value={this.modelFields.find(field => field.value === this.state.y)}
                    className="mr-sm-2"
                    options={this.modelFields}
                    onChange={field => this.setState({ ...this.state, y: field ? field.value : '' })}
                    isSearchable={true} isClearable={true} />
                </div>
              </div>
              {this.state.model
                ? <MainCondition model={this.model} fields={this.fields} value={this.conditions}
                  eKey="conditions" onConditionChanged={this.edit} />
                : null
              }

              <div className="col-md-12 text-center btnsend">
                <Button variant="success" onClick={this.onSave}>Save</Button>
              </div>
            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(DashleadUpdate);